import { Component, Input, Output, EventEmitter } from '@angular/core';
import { cn } from '../../../../utils/utils';
import { CustomizableButtonComponent } from '../customizable-button/customizable-button.component';

@Component({
  selector: 'stepper-controls',
  standalone: true,
  imports: [CustomizableButtonComponent],
  templateUrl: './stepper-controls.component.html',
  styleUrl: './stepper-controls.component.css',
})
export class StepperControlsComponent {
  merge = cn;
  @Input() containerClass: string = '';
  @Input() controlContainerClass: string = '';
  @Input() leftButtonClass: string = '';
  @Input() rightButtonClass: string = '';
  @Input() leftButtonDisabled: boolean = false;
  @Input() rightButtonDisabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() leftButtonLabel: string = 'Previous';
  @Input() rightButtonLabel: string = 'Next';

  @Output() leftButtonClick = new EventEmitter();
  @Output() rightButtonClick = new EventEmitter();

  rightClick() {
    this.rightButtonClick.emit();
  }

  leftClick() {
    this.leftButtonClick.emit();
  }
}
